import React from "react";
import cogoToast from "cogo-toast";
import { useState, useEffect } from "react";
import Select from "react-select";
import {
  createSectorApi,
  listSectorsApi,
  updateSectorApi,
  deleteSectorApi,
  assignUserToSectorApi,
  listSectorAssignmentsApi,
  removeSectorAssignmentApi,
  getUsers,
} from "../../services/Api";
import { SUCCESS_RESULT } from "../../Constants";
import { FaTimes, FaEdit, FaPlus, FaTrash, FaSearch, FaUserPlus, FaUsers } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Card,
  CardBody,
  CardHeader,
  Table,
  Input,
  Form,
  FormGroup,
  Label,
  Row,
  Col,
  Badge,
} from "reactstrap";
import BtnSpinner from "../../components/BtnSpinner";
import Swal from "sweetalert2";

const Divisions = (props) => {
  const history = useHistory();
  const [is_processing, setProcessing] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [creatingSector, setCreatingSector] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    status: 10000,
  });
  const [show_create_dialog, setShow_create_dialog] = useState(false);
  const [show_update_dialog, setShow_update_dialog] = useState(false);
  const [sectorToUpdate, setSectorToUpdate] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all"); // 10000 = active, 10001 = inactive, "all" = all
  const [show_assign_dialog, setShow_assign_dialog] = useState(false);
  const [selectedSector, setSelectedSector] = useState(null);
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [assigningUser, setAssigningUser] = useState(false);
  const [assignmentForm, setAssignmentForm] = useState({
    user_id: "",
    sector_id: "",
    access_level: "DEPARTMENT",
  });
  const [assignments, setAssignments] = useState([]);
  const [loadingAssignments, setLoadingAssignments] = useState(false);

  useEffect(() => {
    fetch_sectors_list();
    loadUsers();
    return () => {};
  }, [statusFilter]);

  const loadUsers = () => {
    setLoadingUsers(true);
    getUsers()
      .then((res) => {
        setLoadingUsers(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setUsers(response.data || []);
          } else {
            cogoToast.error(response.message || "Failed to load users", {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((e) => {
        setLoadingUsers(false);
        const errorMessage =
          e?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
      });
  };

  const create_sector = (e) => {
    e.preventDefault();
    
    if (!formData.name || formData.name.trim() === "") {
      cogoToast.error("Sector name is required", { hideAfter: 3 });
      return;
    }

    if (formData.name.length > 100) {
      cogoToast.error("Sector name must not exceed 100 characters", { hideAfter: 3 });
      return;
    }

    setCreatingSector(true);

    let data = {
      name: formData.name.trim(),
      description: formData.description ? formData.description.trim() : "",
    };

    createSectorApi(data)
      .then((res) => {
        setCreatingSector(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setShow_create_dialog(false);
            resetForm();
            fetch_sectors_list();
            cogoToast.success(response.message || "Sector created successfully", {
              hideAfter: 3,
            });
          } else {
            cogoToast.error(response.message || "Failed to create sector", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to create sector", {
            hideAfter: 5,
          });
        }
      })
      .catch((e) => {
        setCreatingSector(false);
        const errorMessage =
          e?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
      });
  };

  const update_sector = (e) => {
    e.preventDefault();

    if (!sectorToUpdate.name || sectorToUpdate.name.trim() === "") {
      cogoToast.error("Sector name is required", { hideAfter: 3 });
      return;
    }

    if (sectorToUpdate.name.length > 100) {
      cogoToast.error("Sector name must not exceed 100 characters", { hideAfter: 3 });
      return;
    }

    setCreatingSector(true);

    let data = {
      id: sectorToUpdate.id,
      name: sectorToUpdate.name.trim(),
      description: sectorToUpdate.description
        ? sectorToUpdate.description.trim()
        : "",
      status: sectorToUpdate.status || 10000,
    };

    updateSectorApi(data)
      .then((res) => {
        setCreatingSector(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setShow_update_dialog(false);
            setSectorToUpdate({});
            fetch_sectors_list();
            cogoToast.success(response.message || "Sector updated successfully", {
              hideAfter: 3,
            });
          } else {
            cogoToast.error(response.message || "Failed to update sector", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to update sector", {
            hideAfter: 5,
          });
        }
      })
      .catch((e) => {
        setCreatingSector(false);
        const errorMessage =
          e?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
      });
  };

  const fetch_sectors_list = () => {
    setProcessing(true);

    // According to API spec: 10000 = active, 10001 = inactive, send 10001 to get all
    const payload = statusFilter === "all" ? { status: 10001 } : { status: statusFilter };

    listSectorsApi(payload)
      .then((res) => {
        setProcessing(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setRowData(response.data || []);
          } else {
            cogoToast.error(response.message || "Failed to load sectors", {
              hideAfter: 5,
            });
            setRowData([]);
          }
        } else {
          cogoToast.error(res.message || "Failed to load sectors", {
            hideAfter: 5,
          });
          setRowData([]);
        }
      })
      .catch((err) => {
        setProcessing(false);
        cogoToast.error("Something went wrong, please try again.", {
          hideAfter: 5,
        });
        setRowData([]);
      });
  };

  const handleDelete = (sector) => {
    Swal.fire({
      title: "Delete Sector?",
      text: `Are you sure you want to delete "${sector.name}"? This will set it to inactive.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Processing..",
          html: "Please wait...",
          timerProgressBar: true,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
            deleteSectorApi({
              id: sector.id,
            })
              .then((res) => {
                Swal.close();
                if (res.status === 200) {
                  const response = res.data;
                  if (response.status === SUCCESS_RESULT) {
                    fetch_sectors_list();
                    cogoToast.success(
                      response.message || "Sector deleted successfully",
                      {
                        hideAfter: 3,
                      }
                    );
                  } else {
                    cogoToast.error(response.message || "Failed to delete sector", {
                      hideAfter: 5,
                    });
                  }
                } else {
                  cogoToast.error(res.message || "Failed to delete sector", {
                    hideAfter: 5,
                  });
                }
              })
              .catch((e) => {
                Swal.close();
                const errorMessage =
                  e?.response?.data?.message || "Cannot delete sector";
                cogoToast.error(errorMessage, {
                  hideAfter: 5,
                });
              });
          },
        });
      }
    });
  };

  const handleEdit = (sector) => {
    setSectorToUpdate({
      id: sector.id,
      name: sector.name,
      description: sector.description || "",
      status: sector.status,
    });
    setShow_update_dialog(true);
  };

  const openAssignDialog = (sector) => {
    setSelectedSector(sector);
    setAssignmentForm({
      user_id: "",
      sector_id: sector.id,
      access_level: "DEPARTMENT",
    });
    setShow_assign_dialog(true);
    fetchAssignments(sector.id);
  };

  const fetchAssignments = (sectorId) => {
    setLoadingAssignments(true);
    listSectorAssignmentsApi({ sector_id: sectorId })
      .then((res) => {
        setLoadingAssignments(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setAssignments(response.data || []);
          } else {
            cogoToast.error(response.message || "Failed to load assignments", {
              hideAfter: 5,
            });
            setAssignments([]);
          }
        } else {
          setAssignments([]);
        }
      })
      .catch((e) => {
        setLoadingAssignments(false);
        // If API doesn't exist yet, just set empty array
        setAssignments([]);
      });
  };

  const assignUser = (e) => {
    e.preventDefault();

    if (!assignmentForm.user_id) {
      cogoToast.error("Please select a user", { hideAfter: 3 });
      return;
    }

    if (!assignmentForm.sector_id) {
      cogoToast.error("Sector ID is missing", { hideAfter: 3 });
      return;
    }

    setAssigningUser(true);

    assignUserToSectorApi({
      user_id: assignmentForm.user_id,
      sector_id: assignmentForm.sector_id,
      access_level: assignmentForm.access_level,
    })
      .then((res) => {
        setAssigningUser(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setAssignmentForm({
              user_id: "",
              sector_id: assignmentForm.sector_id,
              access_level: "DEPARTMENT",
            });
            fetchAssignments(assignmentForm.sector_id);
            cogoToast.success(response.message || "User assigned successfully", {
              hideAfter: 3,
            });
          } else {
            cogoToast.error(response.message || "Failed to assign user", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to assign user", {
            hideAfter: 5,
          });
        }
      })
      .catch((e) => {
        setAssigningUser(false);
        const errorMessage =
          e?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
      });
  };

  const removeAssignment = (assignment) => {
    Swal.fire({
      title: "Remove Assignment?",
      text: `Are you sure you want to remove this user assignment?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, remove it",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        removeSectorAssignmentApi({ id: assignment.id })
          .then((res) => {
            if (res.status === 200) {
              const response = res.data;
              if (response.status === SUCCESS_RESULT) {
                fetchAssignments(assignment.sector_id);
                cogoToast.success(response.message || "Assignment removed successfully", {
                  hideAfter: 3,
                });
              } else {
                cogoToast.error(response.message || "Failed to remove assignment", {
                  hideAfter: 5,
                });
              }
            } else {
              cogoToast.error(res.message || "Failed to remove assignment", {
                hideAfter: 5,
              });
            }
          })
          .catch((e) => {
            const errorMessage =
              e?.response?.data?.message || "Something went wrong, please try again.";
            cogoToast.error(errorMessage, { hideAfter: 5 });
          });
      }
    });
  };

  const resetForm = () => {
    setFormData({
      name: "",
      description: "",
      status: 10000,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdateInputChange = (e) => {
    const { name, value } = e.target;
    setSectorToUpdate((prev) => ({
      ...prev,
      [name]: name === "status" ? parseInt(value) : value,
    }));
  };

  // Filter data based on search term
  const filteredData = rowData.filter((item) =>
    item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.description?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleString();
    } catch (e) {
      return dateString;
    }
  };

  return (
    <div>
      <div className="page-header d-print-none mb-4">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Sectors Management</h2>
              <div className="text-muted mt-1">
                Create, view, update, and manage sectors
              </div>
            </div>
            <div className="col-auto ms-auto">
              <Button
                color="primary"
                onClick={() => setShow_create_dialog(true)}
                style={{
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                }}
              >
                <FaPlus /> Create Sector
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="container-xl">
        <Card className="shadow-sm">
          <CardHeader>
            <Row>
              <Col md={6}>
                <div className="input-group">
                  <span className="input-group-text">
                    <FaSearch />
                  </span>
                  <Input
                    type="text"
                    placeholder="Search sectors..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </Col>
              <Col md={3}>
                <Input
                  type="select"
                  value={statusFilter}
                  onChange={(e) =>
                    setStatusFilter(
                      e.target.value === "all" ? "all" : parseInt(e.target.value)
                    )
                  }
                >
                  <option value="all">All Sectors</option>
                  <option value={10000}>Active Only</option>
                  <option value={10001}>Inactive Only</option>
                </Input>
              </Col>
              <Col md={3} className="text-end">
                <Button
                  color="secondary"
                  outline
                  onClick={fetch_sectors_list}
                  disabled={is_processing}
                >
                  {is_processing ? "Loading..." : "Refresh"}
                </Button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            {is_processing && filteredData.length === 0 ? (
              <div className="text-center py-5">
                <BtnSpinner
                  is_loading={true}
                  text="Loading sectors..."
                  color="primary"
                />
              </div>
            ) : filteredData.length === 0 ? (
              <div className="text-center py-5">
                <p className="text-muted">No sectors found</p>
              </div>
            ) : (
              <div className="table-responsive">
                <Table hover striped>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.map((sector) => (
                      <tr key={sector.id}>
                        <td>
                          <strong>{sector.name}</strong>
                        </td>
                        <td>{sector.description || "N/A"}</td>
                        <td>
                          <Badge
                            color={sector.status === 10000 ? "success" : "secondary"}
                          >
                            {sector.status === 10000 ? "Active" : "Inactive"}
                          </Badge>
                        </td>
                        <td>{formatDate(sector.created_at)}</td>
                        <td>{formatDate(sector.updated_at)}</td>
                        <td>
                          <Button
                            color="success"
                            size="sm"
                            className="me-2"
                            onClick={() => openAssignDialog(sector)}
                            title="Assign Users"
                          >
                            <FaUserPlus />
                          </Button>
                          <Button
                            color="info"
                            size="sm"
                            className="me-2"
                            onClick={() => handleEdit(sector)}
                            title="Edit"
                          >
                            <FaEdit />
                          </Button>
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => handleDelete(sector)}
                            title="Delete"
                          >
                            <FaTrash />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </CardBody>
        </Card>
      </div>

      {/* Create Modal */}
      <Modal
        isOpen={show_create_dialog}
        toggle={() => {
          setShow_create_dialog(false);
          resetForm();
        }}
        size="lg"
      >
        <ModalHeader
          toggle={() => {
            setShow_create_dialog(false);
            resetForm();
          }}
        >
          Create New Sector
        </ModalHeader>
        <Form onSubmit={create_sector}>
          <ModalBody>
            <FormGroup>
              <Label for="name">
                Sector Name <span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                name="name"
                id="name"
                placeholder="Enter sector name"
                value={formData.name}
                onChange={handleInputChange}
                maxLength={100}
                required
              />
              <small className="text-muted">
                Maximum 100 characters. Must be unique.
              </small>
            </FormGroup>
            <FormGroup>
              <Label for="description">Description</Label>
              <Input
                type="textarea"
                name="description"
                id="description"
                placeholder="Enter sector description (optional)"
                value={formData.description}
                onChange={handleInputChange}
                rows={4}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => {
                setShow_create_dialog(false);
                resetForm();
              }}
            >
              Cancel
            </Button>
            {creatingSector ? (
              <BtnSpinner
                is_loading={true}
                text="Creating..."
                color="primary"
                class="btn btn-primary"
              />
            ) : (
              <Button
                color="primary"
                type="submit"
                style={{
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                }}
              >
                Create Sector
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>

      {/* Update Modal */}
      <Modal
        isOpen={show_update_dialog}
        toggle={() => {
          setShow_update_dialog(false);
          setSectorToUpdate({});
        }}
        size="lg"
      >
        <ModalHeader
          toggle={() => {
            setShow_update_dialog(false);
            setSectorToUpdate({});
          }}
        >
          Update Sector
        </ModalHeader>
        <Form onSubmit={update_sector}>
          <ModalBody>
            <FormGroup>
              <Label for="update_name">
                Sector Name <span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                name="name"
                id="update_name"
                placeholder="Enter sector name"
                value={sectorToUpdate.name || ""}
                onChange={handleUpdateInputChange}
                maxLength={100}
                required
              />
              <small className="text-muted">
                Maximum 100 characters. Must be unique.
              </small>
            </FormGroup>
            <FormGroup>
              <Label for="update_description">Description</Label>
              <Input
                type="textarea"
                name="description"
                id="update_description"
                placeholder="Enter sector description (optional)"
                value={sectorToUpdate.description || ""}
                onChange={handleUpdateInputChange}
                rows={4}
              />
            </FormGroup>
            <FormGroup>
              <Label for="update_status">Status</Label>
              <Input
                type="select"
                name="status"
                id="update_status"
                value={sectorToUpdate.status || 10000}
                onChange={handleUpdateInputChange}
              >
                <option value={10000}>Active</option>
                <option value={10001}>Inactive</option>
              </Input>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => {
                setShow_update_dialog(false);
                setSectorToUpdate({});
              }}
            >
              Cancel
            </Button>
            {creatingSector ? (
              <BtnSpinner
                is_loading={true}
                text="Updating..."
                color="primary"
                class="btn btn-primary"
              />
            ) : (
              <Button
                color="primary"
                type="submit"
                style={{
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                }}
              >
                Update Sector
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>

      {/* Assign Users Modal */}
      <Modal
        isOpen={show_assign_dialog}
        toggle={() => {
          setShow_assign_dialog(false);
          setSelectedSector(null);
          setAssignments([]);
        }}
        size="lg"
      >
        <ModalHeader
          toggle={() => {
            setShow_assign_dialog(false);
            setSelectedSector(null);
            setAssignments([]);
          }}
        >
          Assign Users to Sector: {selectedSector?.name}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={assignUser}>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="user_id">
                    User <span className="text-danger">*</span>
                  </Label>
                  <Select
                    id="user_id"
                    value={
                      assignmentForm.user_id
                        ? {
                            value: assignmentForm.user_id,
                            label: (() => {
                              const user = users.find((u) => u.id === assignmentForm.user_id);
                              if (user) {
                                const name = user.name || user.username || `User ${user.id}`;
                                const email = user.email ? ` (${user.email})` : "";
                                return `${name}${email}`;
                              }
                              return "";
                            })(),
                          }
                        : null
                    }
                    onChange={(selected) =>
                      setAssignmentForm({
                        ...assignmentForm,
                        user_id: selected ? selected.value : "",
                      })
                    }
                    options={users.map((user) => {
                      const name = user.name || user.username || `User ${user.id}`;
                      const email = user.email ? ` (${user.email})` : "";
                      return {
                        value: user.id,
                        label: `${name}${email}`,
                        email: user.email || "",
                        name: name,
                      };
                    })}
                    placeholder="Search and select a user..."
                    isSearchable
                    isClearable
                    filterOption={(option, inputValue) => {
                      const searchTerm = inputValue.toLowerCase();
                      const label = option.label.toLowerCase();
                      const email = option.data.email ? option.data.email.toLowerCase() : "";
                      const name = option.data.name ? option.data.name.toLowerCase() : "";
                      return (
                        label.includes(searchTerm) ||
                        email.includes(searchTerm) ||
                        name.includes(searchTerm)
                      );
                    }}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "38px",
                      }),
                    }}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="access_level">
                    Access Level <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="select"
                    id="access_level"
                    value={assignmentForm.access_level}
                    onChange={(e) =>
                      setAssignmentForm({ ...assignmentForm, access_level: e.target.value })
                    }
                    required
                  >
                    <option value="DEPARTMENT">Department</option>
                    <option value="SECTOR">Sector</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <div className="text-end mb-3">
              <Button
                color="primary"
                type="submit"
                disabled={assigningUser}
                style={{
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                }}
              >
                {assigningUser ? <BtnSpinner loading={true} /> : "Assign User"}
              </Button>
            </div>
          </Form>

          <hr />

          <div className="mt-4">
            <h6>
              <FaUsers className="me-2" />
              Current Assignments
            </h6>
            {loadingAssignments ? (
              <div className="text-center py-3">
                <BtnSpinner loading={true} />
                <p className="mt-2 text-muted">Loading assignments...</p>
              </div>
            ) : assignments.length === 0 ? (
              <p className="text-muted">No users assigned to this sector yet.</p>
            ) : (
              <div className="table-responsive">
                <Table hover striped bordered size="sm">
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Access Level</th>
                      <th>Assigned At</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {assignments.map((assignment) => (
                      <tr key={assignment.id}>
                        <td>
                          {assignment.user?.name ||
                            assignment.user?.username ||
                            assignment.user?.email ||
                            `User ${assignment.user_id}`}
                        </td>
                        <td>
                          <Badge color="info">{assignment.access_level}</Badge>
                        </td>
                        <td>{formatDate(assignment.created_at)}</td>
                        <td>
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => removeAssignment(assignment)}
                            title="Remove Assignment"
                          >
                            <FaTrash />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => {
              setShow_assign_dialog(false);
              setSelectedSector(null);
              setAssignments([]);
            }}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Divisions;
